import React from 'react';
import styles from './Button.module.css';

class Button extends React.Component {
  render() {
    const {
      variant  = 'secondary',
      size     = 'md',
      icon,
      iconPos  = 'left',
      loading  = false,
      disabled = false,
      onClick,
      children,
      style,
      className,
    } = this.props;

    const cls = [
      styles.btn,
      styles[variant],
      styles[size],
      className || '',
    ].filter(Boolean).join(' ');

    return (
      <button
        className={cls}
        onClick={onClick}
        disabled={disabled || loading}
        style={style}
      >
        {loading && <span className={styles.spinner} />}
        {!loading && icon && iconPos === 'left' && <span>{icon}</span>}
        {children}
        {!loading && icon && iconPos === 'right' && <span>{icon}</span>}
      </button>
    );
  }
}

export default Button;
